import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subError, setSubError] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    const honeypot = (e.target as HTMLFormElement).querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setSubStatus('success');
      setEmail('');
      return;
    }

    setSubStatus('loading');
    setSubError('');

    try {
      const form = e.currentTarget as HTMLFormElement;
      const payload = new FormData(form);
      payload.delete('website_alt');

      const response = await fetch('http://guanlist.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg = (
        (parsed?.meta as Record<string, string>)?.message ||
        (parsed?.message as string) ||
        (parsed?.meta as Record<string, string>)?.detail ||
        responseText
      );

      if (response.ok && parsed?.code === 'OK') {
        setSubStatus('success');
        setEmail('');
      } else {
        setSubStatus('error');
        setSubError(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setSubStatus('error');
      setSubError('网络错误，请检查连接后重试');
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-open-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">韩漫之家</span>
              </Link>
              <p className="text-sm text-foreground-300 leading-relaxed mb-5">
                最新高清免费韩国漫画大全，热门韩漫在线阅读平台。每日更新，为您带来最好的韩漫阅读体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="http://guanlist.com/" className="w-9 h-9 rounded-full flex items-center justify-center border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="http://guanlist.com/" className="w-9 h-9 rounded-full flex items-center justify-center border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" rel="nofollow" aria-label="小红书">
                  <i className="ri-red-packet-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full flex items-center justify-center border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full flex items-center justify-center border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" rel="nofollow" aria-label="B站">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-50 mb-5">漫画分类</h4>
              <ul className="flex flex-col gap-3">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-50 mb-5">快速链接</h4>
              <ul className="flex flex-col gap-3">
                <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热门推荐</Link></li>
                <li><Link to="/category/love" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">最新上架</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-50 mb-5">订阅更新</h4>
              <p className="text-sm text-foreground-300 mb-4">第一时间获取最新韩漫上架通知和热门推荐。</p>
              <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱"
                  className="flex-1 bg-foreground-800 text-background-50 text-sm px-4 py-2.5 rounded-md border border-foreground-700 outline-none focus:border-primary-400 transition-colors"
                  required
                />
                <input
                  type="text"
                  name="website_alt"
                  className="form-hp-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly={false}
                />
                <button
                  type="submit"
                  disabled={subStatus === 'loading'}
                  className="bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 text-sm font-medium px-5 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors"
                >
                  {subStatus === 'loading' ? '订阅中...' : '订阅'}
                </button>
              </form>
              {subStatus === 'success' && (
                <p className="text-xs text-accent-400 mt-2">感谢订阅！我们会将最新动态发送到您的邮箱。</p>
              )}
              {subStatus === 'error' && (
                <p className="text-xs text-primary-400 mt-2">{subError || '订阅失败，请稍后重试'}</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2026 韩漫之家. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}